import makeStyles from '@material-ui/core/styles/makeStyles';
var useStyles = makeStyles({
    container: {
        backgroundColor: '#222222',
        width: '100%',
    },
}, { name: 'HorizonGallaryPlaceholder' });
export { useStyles };
